import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { fetchGradeNeurologicalInfo, getGradeBySlug } from '../common/actions';
import { withNamespaces } from 'react-i18next';

class NeurologicalDetails extends Component {
	componentDidMount() {
		this.props.fetchGradeNeurologicalInfo(this.props.match.params.slug);
	}

	render() {
		const { grade, t } = this.props;

		const infoHtml = grade && grade.neurologicalInfo;

		return (<div>{grade &&
			<h3>{grade.name}</h3>}
			{infoHtml && <div dangerouslySetInnerHTML={{ __html: infoHtml }} />}
			<Row className='parent-dashboard-box'>
				<Col sm={12}>
					<Link to='/neurological-info' className='btn btn-back'><FontAwesome name='arrow-circle-left' /> {t('Common_Back')}</Link>
				</Col>
			</Row>
		</div>);
	}
}

const mapStateToProps = (state, ownProps) => {
	const slug = ownProps.match.params.slug;
	const { entities: { grades } } = state;

	return {
		grade: getGradeBySlug(grades, slug)
	};
};

export default connect(mapStateToProps, {
	fetchGradeNeurologicalInfo
})(withNamespaces()(NeurologicalDetails));